<template>
    <q-layout view="lHh lpR fFf" style="background-color: #F3F3F7;">

        <q-dialog v-model="dialogRegiones" position="top">
            <q-card>
                <q-card-section class="row items-center no-wrap">
                    <q-list bordered separator style="width: 400px;">
                        <q-item-label header>Regiones</q-item-label>
                        <q-item :active="active" clickable v-ripple v-for="a in itemsEstados" :key="a.estado"
                            tabindex="0" @click="login(a)">
                            <q-item-section avatar>
                                <q-icon name="mdi-hospital-box" />
                            </q-item-section>
                            <q-item-section>{{ a.estado }}</q-item-section>
                            <q-item-section side>Región</q-item-section>
                        </q-item>

                    </q-list>
                </q-card-section>
            </q-card>
        </q-dialog>

        <!-- DIALOG TIPO DE UNIDADES -->
        <q-dialog v-model="dialogTipoUnidades" persistent>
            <TipoUnidades style="width: 700px; max-width: 80vw;"></TipoUnidades>
        </q-dialog>

        <!-- DIALOG SEDES -->
        <q-dialog v-model="dialogSedes" persistent>
            <Sedes style="width: 700px; max-width: 80vw;"></Sedes>
        </q-dialog>

        <!-- DIALOG UNIDADES -->
        <q-dialog v-model="dialogUnidades" persistent>
            <Unidades style="width: 700px; max-width: 80vw;"></Unidades>
        </q-dialog>

        <!-- DIALOG PERSONAL -->
        <q-dialog v-model="dialogPersonal" persistent>
            <Personal style="width: 700px; max-width: 80vw;"></Personal>
        </q-dialog>

        <q-dialog v-model="dialoConfiguracion" persistent>
            <q-card style="width: 150vw;">
                <q-bar>
                    <q-icon name="mdi-cog" />
                    <div>Configuración</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>

                <q-card-section>
                    <q-scroll-area :thumb-style="thumbStyle" :bar-style="barStyle" style="height: 400px;">
                        <q-list>
                            <q-item clickable v-for="a in listaVariables" :key="a.label" tag="label" v-ripple
                                @click="actualizarVariable(a)">
                                <q-item-section>
                                    <q-item-label>{{ a.label }}</q-item-label>
                                    <q-item-label caption>{{ a.info }}</q-item-label>
                                </q-item-section>
                                <q-item-section avatar>
                                    <q-toggle color="green" v-model="a.value" @input="actualizarVariable(a)" />
                                </q-item-section>
                            </q-item>


                        </q-list>
                    </q-scroll-area>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-header class="rounded-borders q-ma-md " elevated height-hint="64">
            <q-toolbar class="bg-white shadow-1 rounded-borders  q-py-md">
                <q-btn flat round dense>
                    <q-icon class="text-grey" name="mdi-menu" @click="drawer = !drawer" />
                </q-btn>
                <q-toolbar-title @click="dialogRegiones = true" style="cursor: pointer;" class="text-h4 text-primary">
                    <strong>GestorStock </strong>
                    <strong class="text-h5">{{
                        usuarioStore.estado }}</strong>
                </q-toolbar-title>
                <!-- <q-btn flat round dense>
                    <q-icon class="text-grey" name="mdi-menu" @click="miniState = !miniState" />
                </q-btn>
                <q-input dense borderless v-model="text" label="Buscar" input-class="text-left" class="q-ml-md">
                    <template v-slot:prepend>
                        <q-icon v-if="text === ''" class="text-grey" name="mdi-magnify" />
                        <q-icon v-else name="clear" class="cursor-pointer" @click="text = ''" />
                    </template>
</q-input> -->
                <q-space />
                <!-- <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-moon-waning-crescent" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-white-balance-sunny" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-bell" />
                </q-btn> -->
                <!-- <q-avatar class="cursor-pointer">
                    <img :src="adminStore.fotoPerfilBase64">
                    <q-badge color="green" rounded floating />
                    <q-menu content-class="bg-primary text-white" auto-close>
                        <q-list style="min-width: 120px">
                            <q-item clickable to="/dashboard/admin/configuracion">
                                <q-item-section avatar>
                                    <q-icon name="settings" color="white" />
                                </q-item-section>
                                <q-item-section>
                                    Configuración
                                </q-item-section>
                            </q-item>
                            <q-item clickable @click="logout()">
                                <q-item-section avatar>
                                    <q-icon name="mdi-logout" color="white" />
                                </q-item-section>
                                <q-item-section>
                                    Cerrar Sesión
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                </q-avatar> -->
                <q-item>
                    <q-item-section>
                        <q-item-label class="text-bold text-primary">{{ usuarioStore.nombre + " " +
                            usuarioStore.apellidos }}</q-item-label>
                        <q-item-label class="text-prmary" caption>
                            {{ usuarioStore.email }}
                        </q-item-label>
                    </q-item-section>

                    <q-item-section avatar>
                        <q-avatar style="cursor: pointer;">
                            <img src="https://cdn.quasar.dev/img/boy-avatar.png">
                            <q-menu>
                                <div class="row no-wrap q-pa-md ">
                                    <div class="column">
                                        <div class="text-h6">Menu</div>

                                        <q-list class="text-center" style="min-width: 150px">
                                            <q-item clickable @click="configQR()">
                                                <q-item-section>Configuración de QR</q-item-section>
                                            </q-item>

                                            <q-separator />
                                            <q-item clickable class="text-red" active v-ripple @click="salir()">
                                                <q-item-section>
                                                    Cerrar Sesión
                                                </q-item-section>
                                            </q-item>
                                        </q-list>
                                    </div>
                                    <q-separator vertical inset class="q-mx-lg" />
                                    <div class="column items-center">
                                        <q-avatar style="border: solid 3px #f1f2f4;" size="72px">
                                            <img src="https://cdn.quasar.dev/img/boy-avatar.png">
                                        </q-avatar>
                                        <div class="text-subtitle1 q-mt-md q-mb-xs text-center">{{ usuarioStore.nombre +
                                            " " +
                                            usuarioStore.apellidos }}</div>
                                        <q-btn color="primary" label="Editar" push size="sm" v-close-popup />
                                    </div>
                                </div>
                            </q-menu>
                        </q-avatar>
                    </q-item-section>
                </q-item>
            </q-toolbar>
        </q-header>

        <q-drawer v-model="drawer" show-if-above :width="250" :breakpoint="500" content-class="bg-white">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list class="q-pa-md rounded-borders text-primary">
                    <div class=" text-center">
                        <img src="../../assets/logo_gestor.png"
                            style="  cursor:pointer ; width: 200px; height: auto;  cursor:pointer;" fit="contain"
                            class="logo-image" />
                    </div>
                    <q-item clickable v-ripple :active="link === 'inicio'" @click="link = 'inicio', irHome()"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-home" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Inicio
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'reportes'" @click="link = 'reportes', irReportes()"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-chart-arc" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Reportes
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple @click="  abrirDialogPersonal()" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-account-group" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Personal
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple @click=" abrirDialogSedes()" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-map-marker-multiple" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Sedes
                        </q-item-section>
                    </q-item>
                    <q-item clickable v-ripple @click=" abrirDialogTipoUnidad()" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-hospital-box" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Tipo de Unidades
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple @click="abrirDialogUnidad()" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-hospital-building" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Unidades
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'bases-datos'"
                        @click="link = 'bases-datos', irBaseDatos()" active-class="my-menu-link"
                        class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-database-plus" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Bases de Datos
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'brigadas'" @click="link = 'brigadas', irBrigadas()"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-group" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Brigadas
                        </q-item-section>
                    </q-item>

                    <q-item v-if="usuarioStore.rol == 'Administrador'" clickable v-ripple
                        :active="link === 'quirofanos'" @click="link = 'quirofanos', irQuirofanos()"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-stethoscope" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Quirófanos
                        </q-item-section>
                    </q-item>

                    <q-item v-if="usuarioStore.rol == 'Administrador'" clickable v-ripple
                        :active="link === 'conciliacion'" @click="link = 'conciliacion', irConciliacion()"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-vector-union" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Conciliación
                        </q-item-section>
                    </q-item>

                    <q-item v-if="usuarioStore.rol == 'Administrador'" clickable v-ripple :active="link === 'usuarios'"
                        @click="link = 'usuarios', irUsuarios()" active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="mdi-account-multiple-plus" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Usuarios
                        </q-item-section>
                    </q-item>

                </q-list>
            </q-scroll-area>
        </q-drawer>

        <!-- <q-header elevated>
            <q-toolbar class="q-px-xl q-mt-md">
                <q-toolbar-title class="text-h4">
                    <strong>GestorStock </strong>
                    <strong class="text-h5">{{ usuarioStore.estado }}</strong>
                </q-toolbar-title>
                <q-space />

                <q-item>
                    <q-item-section>
                        <q-item-label class="text-bold">{{ usuarioStore.nombre + " " +
                            usuarioStore.apellidos }}</q-item-label>
                        <q-item-label class="text-white" caption>
                            {{ usuarioStore.email }}
                        </q-item-label>
                    </q-item-section>

                    <q-item-section avatar>
                        <q-avatar style="cursor: pointer;">
                            <img src="https://cdn.quasar.dev/img/boy-avatar.png">
                            <q-menu>
                                <div class="row no-wrap q-pa-md ">
                                    <div class="column">
                                        <div class="text-h6">Menu</div>

                                        <q-list class="text-center" style="min-width: 150px">
                                            <q-item clickable @click="configQR()">
                                                <q-item-section>Configuración de QR</q-item-section>
                                            </q-item>
                                            <q-separator />
                                            <q-item clickable @click="irUsuarios()">
                                                <q-item-section>Usuarios</q-item-section>
                                            </q-item>
                                            <q-separator />
                                            <q-item clickable class="text-red" active v-ripple @click="salir()">
                                                <q-item-section>
                                                    Cerrar Sesión
                                                </q-item-section>
                                            </q-item>
                                        </q-list>
                                    </div>
                                    <q-separator vertical inset class="q-mx-lg" />
                                    <div class="column items-center">
                                        <q-avatar style="border: solid 3px #f1f2f4;" size="72px">
                                            <img src="https://cdn.quasar.dev/img/boy-avatar.png">
                                        </q-avatar>
                                        <div class="text-subtitle1 q-mt-md q-mb-xs text-center">{{ usuarioStore.nombre +
                                            " " +
                                            usuarioStore.apellidos }}</div>
                                        <q-btn color="primary" label="Editar" push size="sm" v-close-popup />
                                    </div>
                                </div>
                            </q-menu>
                        </q-avatar>
                    </q-item-section>
                </q-item>
            </q-toolbar>
            <q-toolbar class="bg-primary text-white q-px-xl shadow-none">
                <q-btn size="sm" stretch flat icon="home" label="Inicio" @click="irHome()" />
                <q-separator dark vertical />
                <q-btn size="sm" icon="mdi-account-group" stretch flat label="Personal"
                    @click="abrirDialogPersonal()" />
                <q-separator dark vertical />
                <q-btn size="sm" icon="mdi-map-marker-multiple" stretch flat label="Sedes"
                    @click="abrirDialogSedes()" />
                <q-separator dark vertical />
                <q-btn size="sm" icon="mdi-hospital-box" stretch flat label="Tipo de Unidades"
                    @click="abrirDialogTipoUnidad()" />
                <q-separator dark vertical />
                <q-btn size="sm" icon="mdi-hospital-building" stretch flat label="Unidades"
                    @click="abrirDialogUnidad()" />
                <q-separator dark vertical />
                <q-btn size="sm" icon="mdi-database-plus" stretch flat label="Bases de Datos" @click="irBaseDatos()" />
                <q-separator dark vertical />
                <q-btn size="sm" icon="mdi-group" stretch flat label="Brigadas" @click="irBrigadas()" />
                <q-separator dark vertical />

                <q-space />

                <q-btn-dropdown size="sm" icon="mdi-map-marker-radius" stretch flat label="Estados">
                    <q-list>
                        <q-item v-for="a in itemsEstados" clickable v-close-popup tabindex="0" @click="login(a)">
                            <q-item-section>
                                <q-item-label>{{ a.estado }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>

            </q-toolbar>
        </q-header> -->


        <q-page-container>
            <router-view />
        </q-page-container>

    </q-layout>
</template>

<script>
import moment from 'moment';
import axios from "axios";
import TipoUnidades from '../TipoUnidades/TipoUnidades.vue';
import Sedes from '../Sedes/Sedes.vue';
import Unidades from '../Unidades/Unidades.vue';
import Personal from '../Personal/Personal.vue';
export default {

    components: {
        TipoUnidades, Sedes, Unidades, Personal
    },

    data() {
        return {
            active: true,
            dialogRegiones: false,
            drawer: false,
            miniState: false,
            dialoConfiguracion: false,
            config: {
                nombre: ''
            },
            link: 'inicio',
            leftDrawerOpen: false,

            filter: '',
            dataBienes: [],
            columnsBienes: [
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'numero_emp', align: 'center', label: 'Número', field: 'numero_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nombre_emp', align: 'center', label: 'Nombre del Bien', field: 'nombre_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'descripcion_emp', align: 'center', label: 'Descripción', field: 'descripcion_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'marca_emp', align: 'center', label: 'Marca', field: 'marca_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'serie_emp', align: 'center', label: 'Serie', field: 'serie_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'modelo_emp', align: 'center', label: 'Modelo', field: 'modelo_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'est_conserv_emp', align: 'center', label: 'Estado Conservación', field: 'est_conserv_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'ubicacion_emp', align: 'center', label: 'Ubicación', field: 'ubicacion_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'usuario_emp', align: 'center', label: 'Usuario', field: 'usuario_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'resultado_emp', align: 'center', label: 'Resultado Toma Física', field: 'resultado_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'obeservaciones_emp', align: 'center', label: 'Obeservaciones', field: 'obeservaciones_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            loadingBienes: false,

            dialogTipoUnidades: false,
            dialogSedes: false,
            dialogUnidades: false,
            dialogPersonal: false,

            itemsEstados: [],
            listaVariables: [],

            thumbStyle: {
                right: '4px',
                borderRadius: '5px',
                backgroundColor: '#027be3',
                width: '5px',
                opacity: 0.75
            },

            barStyle: {
                right: '2px',
                borderRadius: '9px',
                backgroundColor: '#027be3',
                width: '9px',
                opacity: 0.2
            }
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario
        },

    },
    created() {
        this.GetEstados()
    },
    methods: {
        abrirDialogUnidad() {
            this.dialogUnidades = true
            this.$store.state.unidadStore = {
                _id: '',
                unidad: '',
                _id_tipo_uinidad: '',
                _id_sede: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },
        abrirDialogTipoUnidad() {
            this.dialogTipoUnidades = true
            this.$store.state.tipoUnidadesStore = {
                _id: '',
                tipo_uinidad: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },

        abrirDialogSedes() {
            this.dialogSedes = true
            this.$store.state.sedeStore = {
                _id: '',
                sede: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },

        abrirDialogPersonal() {
            this.$store.state.personalStore = {
                _id: '',
                nombre: '',
                correo: '',
                password: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
            this.dialogPersonal = true
        },

        async salir() {
            this.$q.loading.show({ message: '<b>Cerrando Sesión...</b>' })
            try {
                this.$q.loading.hide()
                this.$store.dispatch("salir");
            } catch (err) {
                console.log(err);
                this.$q.loading.hide()
            }
        },
        irBaseDatos() {
            this.$router.push({ name: 'BaseDatos' })
        },
        irBrigadas() {
            this.$router.push({ name: 'Brigadas' })
        },
        irHome() {
            this.$router.push({ name: 'Home' })
        },
        irUsuarios() {
            this.$router.push({ name: 'Usuarios' })
        },
        irReportes() {
            this.$router.push({ name: 'Reportes' })
        },
        irQuirofanos() {
            this.$router.push({ name: 'Quirofanos' })
        },
        irConciliacion() {
            this.$router.push({ name: 'Conciliacion' })
        },
        async GetEstados() {
            try {
                let response = await axios.get('Login/GetEstados/' + this.usuarioStore._id)
                console.log(response)
                this.itemsEstados = response.data
            } catch (error) {
                console.log(error)
            }
        },
        async login(estado) {
            if (estado.estado == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', icon: 'mdi-information', message: 'Seleccione el estado para acceder a su información.', timeout: 2000 })
                return
            }
            let objeto = {
                username: this.usuarioStore.email,
                estado: estado.estado,
                baseDatos: estado.baseDatos
            }
            this.$q.loading.show({ message: '<b>Cambiando de Estado...</b>' })
            try {
                let response = await axios.post(`Login/PostLoginAsync/`, objeto);
                console.log(response.data)

                this.$store.dispatch("guardarToken", response.data);
                this.$router.push({ name: "Inicio" });
                this.$q.loading.hide();
                location.reload();
            } catch (error) {
                console.log(error)
                this.$q.loading.hide();
                this.$q.notify({ type: 'negative', message: error.response.data });
            }
        },
        async configQR() {
            this.dialoConfiguracion = true
            try {
                let response = await axios.get(`Configuracion/GetDatosQR/config_inventarios`);
                console.log(response)
                this.listaVariables = response.data
            } catch (error) {
                console.log(error)
            }
        },
        async actualizarVariable(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            console.log(item.value)
            try {
                let response = await axios.put(`Configuracion/PutVariabele/config_inventarios/` + item._id + '/' + item.value);
                console.log(response)
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style>
.q-cards {
    text-align: center;
    background-color: rgb(255, 255, 255);
    color: #424242;
    border-radius: 10px;
}

.text-subtitle1 {
    color: #1A4161;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
}

.q-page-container {
    height: calc(100vh - 0px);
    /* 64px = altura del header, ajusta si tu header es más grande */
    overflow: hidden;
    padding: 0;
}

.q-page {
    height: 100%;
    overflow: hidden;
}

.scrollable-card-container {
    height: 100%;
    overflow-y: auto;
}

.bg-purple {
    background: linear-gradient(45deg, #6a52fa, #a17ff9);
}

.class-menu-icono {
    color: #697A8D;
}

.my-menu-link {
    color: white !important;
    background: #154F39;
}

.my-menu-link i {
    color: white;
}

.q-page-container {
    overflow: hidden;
}

/* Ajustes cuando el drawer está en modo mini */
.mini-logo-container {
    padding: 8px !important;
    /* Ajusta el padding para el modo mini */
}

/* Puedes ajustar el color de fondo si lo deseas */
.q-drawer.bg-white {
    background-color: #ffffff;
}
</style>
